<!--
  wanglu 2020.9.27 微信支付
-->
<template>
  <section>
    <div class="shortcut">
      <div class="w">
        <a
          class="s-logo"
          href='/home'
        >
          <img
            width="auto"
            height="38"
            alt="开心云商"
            src="../../../assets/images/account_logo.png"
          >
        </a>
        <ul class="s-right">
          <li class="s-item fore1">
            <a
              href="//home.jd.com/"
              target="_blank"
              class="link-user"
            >{{userName}}</a>
          </li>
          <li class="s-div">|</li>
          <li
            class="s-item fore2"
            v-show='showOrderList'
          >
            <a
              class="op-i-ext"
              href="/member/order?status=-1"
              target="_blank"
            >我的订单</a>
          </li>
          <li
            class="s-item fore2"
            v-show='!showOrderList'
          >
            <a
              class="op-i-ext"
              href="/account-center"
              target="_blank"
            >我的账户</a>
          </li>
          <li class="s-div">|</li>
          <li class="s-item fore3">
            <a
              class="op-i-ext"
              target="_blank"
              href="/help"
            >支付帮助</a>
          </li>
        </ul>
        <span class="clr"></span>
      </div>
    </div>
    <div class="main">
      <div class="w">
        <!-- order 订单信息 -->
        <div class="order clearfix order-init order-init-oldUser-noQrcode">
          <!-- 订单信息 -->
          <div
            class="o-left"
            v-show='showOrderList'
          >
            <h3 class="o-title">订单提交成功，请尽快付款！订单号：{{orderList}}</h3>
            <p class="o-tips">

            </p>
          </div>
          <!-- 订单信息 end -->
          <!-- 订单金额 -->
          <div class="o-right">
            <div class="o-price"><em>应付金额</em><strong>{{totalAmount}}</strong><em>元</em></div>
          </div>
          <!-- 订单金额 end -->
          <div
            class="o-list j_orderList"
            id="listPayOrderInfo"
          >
            <!-- 单笔订单 -->
          </div>
        </div>

        <!-- payment 支付方式选择 -->
        <div class="payment">
          <!-- 微信支付 -->
          <div class="pay-weixin">
            <div class="p-w-hd">支付宝支付</div>
            <div
              class="p-w-bd"
              style="position:relative"
            >
              <!--                        <div class="j_weixinInfo font-red" style="position:absolute; top: -36px; left: 130px;">二维码已过期，<a href="javascript:getWeixinImage2();">刷新</a>页面重新获取二维码。</div> -->
              <div
                class="j_weixinInfo"
                style="position:absolute; top: -36px; left: 130px;"
              >距离二维码过期还剩<span class="j_qrCodeCountdown font-bold font-red">{{count}}</span>秒，过期后请重新获取二维码。</div>
              <div class="p-w-box">
                <div class="pw-box-hd">
                  <div
                    id="weixinImageUrl"
                    class="qrcode"
                    ref="qrCodeUrl"
                  ></div>
                </div>
                <!--                             <div class="pw-retry j_weixiRetry">
                                <a class="ui-button ui-button-gray j_weixiRetryButton" href="javascript:getWeixinImage2();">获取失败 点击重新获取二维码  </a>
                            </div> -->
                <div class="pw-error j_weixiError"></div>
                <div class="pw-box-ft">
                  <p>请使用支付宝扫一扫</p>
                  <p>扫描二维码支付</p>
                </div>
              </div>
              <div class="p-w-sidebar"></div>
            </div>
          </div>
          <!-- 微信支付 end -->
          <!-- payment-change 变更支付方式 -->
          <div
            class="payment-change"
            id="return_weixin_jd"
          >
            <a
              class="pc-wrap "
              onclick="window.history.go(-1)"
            >
              <i class="pc-w-arrow-left">&lt;</i>
              <strong>选择其他支付方式</strong>
            </a>
          </div>
          <!-- payment-change 变更支付方式 end -->
        </div>
        <!-- payment 支付方式选择 end -->
      </div>
    </div>
  </section>
</template>
<script>
import axios from "axios";
import { getSession, setSession, removeSession } from "utils/tool";
import { getOrderDetail } from "api/order";
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      payUrl: "", //二维码地址
      orderId: "", //订单id
      orderList: "", //订单号
      totalAmount: "", //金额
      payType: "", //付款类型
      userName: "", //用户名
      count: 60, //60s倒计时
      timer: null, //倒计时
      timerOrder: null, //订单支付
      showOrderList: true, //显示订单号
    };
  },
  created() {
    this.payUrl = this.$route.query.payUrl;
    this.orderId = this.$route.query.orderId;
    this.orderList = this.$route.query.orderList;
    this.totalAmount = this.$route.query.totalAmount;
    this.payType = this.$route.query.payType;
    this.userName = getSession("userName");
    if (getSession("X_no_time") == null || getSession("X_no_time") == "") {
      this.cutDown();
    } else {
      this.count = Number(getSession("X_no_time"));
      this.cutDown();
    }

    //微信支付类型 recharge充值 order 订单支付;
    if (this.payType == "order") {
      this.getOrderDetail();
    }
    if (this.payType == "recharge") {
      this.showOrderList = false;
      this.queryPayUrl();
    }
  },
  methods: {
    creatQrCode() {
      //生成二维码
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: this.payUrl, // 需要转换为二维码的内容
        width: 298,
        height: 298,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    cutDown() {
      //倒计时
      let self = this;
      if (!self.timer) {
        self.timer = setInterval(() => {
          self.count--;
          setSession("X_no_time", self.count);
          if (getSession("X_no_time") <= "0") {
            removeSession("X_no_time");
          }
          if (self.count <= 0) {
            //小于或者等于0时
            clearInterval(self.timer);
            if (self.payType == "recharge") {
              layer.confirm(
                "是否支付成功?",
                {
                  btn: ["确定", "取消"],
                },
                function () {
                  layer.close(layer.index);
                  self.$router.push({ path: "/account-center" });
                },
                function () {
                  window.history.go(-1);
                }
              );
            } else {
              window.history.go(-1);
            }
          }
          //  else {
          //  clearInterval(this.timer);

          //  this.timer = null;
          //  window.history.go(-1)
          // }
        }, 1000);
      }
    },
    //获取订单支付状态
    getOrderDetail() {
      let self = this;
      let orderNo = self.orderList.split(",");
      self.timerOrder = setInterval(() => {
        getOrderDetail({ orderNo: orderNo[0] }).then((res) => {
          if (res.resCode == 1) {
            if (res.data.payStatus == 2) {
              clearInterval(self.timerOrder);
              clearInterval(self.timer);
              self.$Message.success("支付成功");
              self.$router.replace({ path: "/member/order?status=-1" });
            }
          } else {
            clearInterval(self.timerOrder);
            self.$Message.warning(res.resDesc);
          }
        });
      }, 2000);
    },
    queryPayUrl() {
      let self = this;
      self.timerOrder = setInterval(() => {
        axios.get(this.$route.query.queryUrl).then((res) => {
          if (res.data.status == "succeeded") {
            clearInterval(self.timerOrder);
            clearInterval(self.timer);
            self.$Message.success("充值成功");
            self.$router.push({ path: "/account-center" });
          }
        });
      }, 2000);
    },
  },
  mounted() {
    this.creatQrCode();
  },
  beforeDestroy() {
    clearInterval(this.timerOrder);
  },
};
</script>
<style lang="less" type="text/less" scoped>
.shortcut {
  width: 100%;
  height: 50px;
}
.shortcut .w {
  position: relative;
  height: 50px;
}
.w {
  width: 990px;
  margin: 0 auto;
}
.shortcut .s-logo {
  position: absolute;
  left: 0;
  top: 15px;
}
.shortcut .s-right {
  float: right;
  padding-top: 20px;
}
.shortcut .s-right .s-item {
  height: 20px;
  line-height: 20px;
  padding: 0 11px 0 12px;
  float: left;
}
.shortcut .s-right .s-div {
  float: left;
  color: #ddd;
}
.shortcut a {
  color: #666;
}
.clr {
  display: block;
  overflow: hidden;
  clear: both;
  height: 0;
  line-height: 0;
  font-size: 0;
}
.main {
  background-color: #fff;
  padding-bottom: 50px;
}
.order {
  position: relative;
  *zoom: 1;
}
.order .o-left {
  float: left;
  width: 640px;
  padding-top: 32px;
  padding-bottom: 32px;
  padding-left: 102px;
}
.order.order-init .o-left {
  padding-left: 0;
  transition: all 0.15s ease-in-out;
}
.order .o-title {
  line-height: 26px;
  height: 26px;
  overflow: hidden;
  color: #333;
  font-weight: 400;
  font-size: 14px;
  font-family: "Microsoft Yahei";
}
.order.order-init .o-tips {
  visibility: hidden;
  opacity: 0;
  transition: all 0.2s ease-in-out;
}
.order .o-tips {
  line-height: 20px;
  height: 20px;
}
.order.order-init.order-init-oldUser-noQrcode .o-tips {
  visibility: visible;
  opacity: 1;
}
.order .o-right {
  float: right;
  width: 190px;
  padding-top: 32px;
  padding-bottom: 10px;
  padding-right: 10px;
  overflow: hidden;
}
.order .o-price {
  text-align: right;
  line-height: 26px;
}
.order .o-price em {
  vertical-align: bottom;
}
.order .o-price strong {
  font-size: 18px;
  vertical-align: bottom;
  color: #e31613;
  margin: 0 3px;
}
.order .o-list {
  display: none;
  padding: 12px 0 25px 0;
  margin: 0 30px;
  clear: both;
  border-top: 1px solid #ddd;
}
.payment {
  background-color: #fff;
  padding: 12px 30px;
  box-shadow: 0 6px 32px rgba(0, 0, 0, 0.13);
}
.p-w-bd,
.pay-weixin {
  zoom: 1;
}
.p-w-hd {
  margin-bottom: 20px;
  font-size: 18px;
  font-family: "Microsoft Yahei";
}
.p-w-bd {
  padding-left: 130px;
  margin-bottom: 30px;
}
.p-w-bd:after,
.pay-weixin:after {
  display: table;
  content: "";
  clear: both;
}
.font-red {
  color: #e31613;
}
.p-w-box {
  float: left;
  width: 300px;
}
.p-w-sidebar {
  float: left;
  width: 379px;
  height: 421px;
  padding-left: 50px;
  margin-top: -20px;
  background: url(//storage.360buyimg.com/payment-assets/pc/icon/phone-bg.png)
    50px 0 no-repeat;
}
.pw-box-hd {
  margin-bottom: 20px;
  border: 1px solid #ddd;
  width: 298px;
  height: 298px;
}
.pw-box-hd img {
  width: 298px;
  height: 298px;
  background: url(//storage.360buyimg.com/payment-assets/pc/icon/ui-modal-loading.gif)
    center center no-repeat;
}
.pw-retry {
  display: none;
  position: absolute;
  width: 300px;
  height: 300px;
  left: 130px;
  top: 0;
  background: rgba(0, 0, 0, 0.4);
  overflow: hidden;
  text-align: center;
}
.pay-weixin .pw-error {
  display: none;
  position: absolute;
  width: 300px;
  height: 300px;
  left: 130px;
  top: 0;
  overflow: hidden;
  line-height: 300px;
  text-align: center;
  background: #ccc;
}
.pw-box-ft {
  height: 44px;
  padding: 8px 0 8px 125px;
  background: #ff7674
    url(//storage.360buyimg.com/payment-assets/pc/icon/icon-red.png) 50px 8px
    no-repeat;
}
.pw-box-ft p {
  margin: 0;
  font-size: 14px;
  line-height: 22px;
  color: #fff;
  font-weight: 700;
}
.p-w-sidebar {
  float: left;
  width: 379px;
  height: 421px;
  padding-left: 50px;
  margin-top: -20px;
  background: url(//storage.360buyimg.com/payment-assets/pc/icon/phone-bg.png)
    50px 0 no-repeat;
}
.ui-button {
  display: inline-block;
  height: 32px;
  line-height: 32px;
  padding: 0 28px;
  color: #fff;
  border: 1px solid #e31613;
  background: #ff403d;
  background: linear-gradient(#ff403d, #e31613);
  border-radius: 2px;
  vertical-align: middle;
  cursor: pointer;
  text-align: center;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  box-shadow: 0 1px 0 0 #fe8c8a inset;
}
.ui-button-gray {
  background: #f1f2f7;
  filter: none;
  box-shadow: none;
  text-shadow: none;
  border-color: #999;
  color: #666;
}
a.ui-button {
  height: 30px;
  line-height: 30px;
}
.pw-retry .ui-button {
  margin-top: 135px;
}
.payment-change .pc-wrap {
  display: block;
  height: 60px;
  line-height: 56px;
  padding: 0 20px;
  transition: all 0.1s;
}
.payment-change .pc-wrap .pc-w-arrow-left,
.payment-change .pc-wrap .pc-w-arrow-right {
  float: right;
  font-family: "\5b8b\4f53";
  font-style: normal;
  font-size: 22px;
  width: 20px;
  text-align: center;
  color: #2fa1dd;
}
.payment-change .pc-wrap .pc-w-arrow-left {
  float: left;
  margin-right: 15px;
}
.payment-change .pc-wrap strong {
  color: #67a4ff;
  margin-right: 30px;
  font-size: 14px;
  float: left;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// aliPage.vue?8f4c4496